import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "./content";

const LangContext = createContext({
    lang: "fr",
    setLang: () => {},
    t: translations.fr,
});

export const LangProvider = ({ children }) => {
    const detect = () => {
        try {
            const saved = localStorage.getItem("sitmec_lang");
            if (saved === "fr" || saved === "en") return saved;
            const nav = (navigator.language || "fr").toLowerCase();
            return nav.startsWith("en") ? "en" : "fr";
        } catch {
            return "fr";
        }
    };

    const [lang, setLangState] = useState(detect);

    const setLang = useCallback((next) => {
        setLangState(next);
        try {
            localStorage.setItem("sitmec_lang", next);
        } catch {}
    }, []);

    useEffect(() => {
        document.documentElement.lang = lang;
        document.title =
            (translations[lang] && translations[lang].meta.title) || "SITMEC";
    }, [lang]);

    return (
        <LangContext.Provider
            value={{ lang, setLang, t: translations[lang] || translations.fr }}
        >
            {children}
        </LangContext.Provider>
    );
};

export const useLang = () => useContext(LangContext);
